import { setTags } from '@sentry/nextjs';

const SentryInitializer = () => {
  setTags({
    service: 'status-board',
  });

  return null;
};

export default SentryInitializer;
